import React, { FC } from 'react';

import noop from 'utils/noop';

import { OptInDialog } from './loyalty-opt-in-modal.styled';
import { ILoyaltyOptInModalViewProps } from './types';

export const LoyaltyOptInModalContentView: FC<ILoyaltyOptInModalViewProps> = ({ dialogProps }) => (
  <OptInDialog
    heading=""
    showCloseButton={false}
    onDismiss={noop}
    modalAppearanceEventMessage="Opt In Modal"
    {...dialogProps}
  />
);
